module.exports = __webpack_public_path__ + "img/material.11453280.svg";